<template>
  <div class="vx-col w-full">
    <vs-table class="w-full" :data="data">
      <template slot="header">
        <add-button :btnText="$t('add_recipient')" @click="add"/>
        <div class="con-input-search vs-table--search">
          <input
            class="input-search vs-table--search-input"
            type="text"
            v-model="text"
            @keypress.enter="search"
          />
          <vs-icon icon="search"></vs-icon>
        </div>
      </template>
      <template slot="thead">
        <!-- <th class="qb-sticky" :style="{background:'white'}"></th> -->
        <th-sort
          :text="$t('client')"
          column="Cl.ClientId"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('name')"
          column="Recipients.name"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('email')"
          column="Recipients.email"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('notify_invoicing')"
          column="Recipients.NotifyInvoicing"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('notify_sca')"
          column="Recipients.NotifySCA"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('notify_ageing')"
          column="Recipients.NotifyAgeing"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('notify_open_expenses')"
          column="Recipients.NotifyOpenExpenses"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('cc')"
          column="Recipients.Cc"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('notify_funding')"
          column="Recipients.NotifyFunding"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('notify_shelter_fee')"
          column="Recipients.NotifyShelterFee"
          @sort="handleClickSort"
        />
        <th class="qb-sticky">
          {{ $t('actions') }}
        </th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>{{ data[i].client_name }} </vs-td>
          <vs-td> {{ data[i].Name }} </vs-td>
          <vs-td> {{ data[i].Email }} </vs-td>
          <vs-td class="text-center">
            <feather-icon
              :icon="data[i].NotifyInvoicing !== '1' ? 'XIcon' : 'CheckIcon'"
              class="m-0 cursor-pointer"
              :svgClasses="
                data[i].NotifyInvoicing !== '1' ? 'text-danger' : 'text-success'
              "
            />
          </vs-td>
          <vs-td class="text-center">
            <feather-icon
              :icon="data[i].NotifySCA !== '1' ? 'XIcon' : 'CheckIcon'"
              class="m-0 cursor-pointer"
              :svgClasses="
                data[i].NotifySCA !== '1' ? 'text-danger' : 'text-success'
              "
            />
          </vs-td>
          <vs-td class="text-center">
            <feather-icon
              :icon="data[i].NotifyAgeing !== '1' ? 'XIcon' : 'CheckIcon'"
              class="m-0 cursor-pointer"
              :svgClasses="
                data[i].NotifyAgeing !== '1' ? 'text-danger' : 'text-success'
              "
            />
          </vs-td>
          <vs-td class="text-center">
            <feather-icon
              :icon="data[i].NotifyOpenexpenses !== '1' ? 'XIcon' : 'CheckIcon'"
              class="m-0 cursor-pointer"
              :svgClasses="
                data[i].NotifyOpenexpenses !== '1'
                  ? 'text-danger'
                  : 'text-success'
              "
            />
          </vs-td>
          <vs-td class="text-center">
            <feather-icon
              :icon="data[i].Cc !== '1' ? 'XIcon' : 'CheckIcon'"
              class="m-0 cursor-pointer"
              :svgClasses="data[i].Cc !== '1' ? 'text-danger' : 'text-success'"
            />
          </vs-td>
          <vs-td class="text-center">
            <feather-icon
              :icon="data[i].NotifyFunding !== '1' ? 'XIcon' : 'CheckIcon'"
              class="m-0 cursor-pointer"
              :svgClasses="
                data[i].NotifyFunding !== '1' ? 'text-danger' : 'text-success'
              "
            />
          </vs-td>
          <vs-td class="text-center">
            <feather-icon
              :icon="data[i].NotifyShelterFee !== '1' ? 'XIcon' : 'CheckIcon'"
              class="m-0 cursor-pointer"
              :svgClasses="
                data[i].NotifyShelterFee !== '1'
                  ? 'text-danger'
                  : 'text-success'
              "
            />
          </vs-td>
          <vs-td>
            <div>
              <action-icon icon="EditIcon" :tooltip="$t('edit')" @click="edit(data[i])"/>
            </div>
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import ActionPdfViewer from '@/views/components/actions/ActionPdfViewer'
import mixins from '@/mixins'
import AddButton from '@/views/components/buttons/AddButton.vue'

export default {
  components: {
    ActionIcon,
    ThSort,
    ActionPdfViewer,
    AddButton,
  },
  data: () => ({
    text: '',
  }),
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
    edit(data){
      this.$emit('edit',data)
    },
    add(){
      this.$emit('add')
    }
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
/* .vs-con-table .vs-con-tbody {
  height: 80vh;
  width: calc(100vw - 160px);
  overflow: auto;
} */
</style>
